export default __webpack_public_path__ + "static/063-dc50e3dcfc837b547cea374af49dcec9.jpg";